import {Checkbox} from 'material-ui';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import React, {Component} from 'react';
import styled from 'styled-components';

import {Col, Row} from '../Grid';
import {TopBarButton} from '../form/FormElements';
import config from '../../config';

const SCheckbox = styled(Checkbox)`
  margin-bottom: 16px;
`;

export default class HideColumnModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
      hiddenColumns: config.getHiddenColumns(),
    };
  }

  handleOpenClick = () => {
    this.setState({open: true});
  };

  handleCloseClick = () => {
    const {hiddenColumns} = this.state;
    config.saveHiddenColumns(hiddenColumns);
    this.setState({open: false});
    if (this.props.callback) this.props.callback(hiddenColumns);
  };

  handleStateChange = id => () => {
    const {hiddenColumns} = this.state;
    if (hiddenColumns.includes(id)) {
      this.setState({hiddenColumns: hiddenColumns.filter(element => element !== id)});
    } else {
      this.setState({hiddenColumns: [...hiddenColumns, id]});
    }
  };

  render() {
    const {open, hiddenColumns} = this.state;
    const {columns} = this.props;
    return (
      <span>
        <TopBarButton onClick={this.handleOpenClick}>SPALTEN</TopBarButton>

        <Dialog
          title="Sichtbare Spalten"
          modal
          open={open}
          actions={[<FlatButton label="übernehmen" onTouchTap={this.handleCloseClick} />]}>
          <Row>
            {columns.map((element, idx) => {
              return (
                <Col key={idx} size={0.5}>
                  <SCheckbox
                    label={element.header}
                    onCheck={this.handleStateChange(element.id)}
                    checked={!hiddenColumns.includes(element.id)}
                  />
                </Col>
              );
            })}
          </Row>
        </Dialog>
      </span>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/table/HideColumnModal.js